import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HelpIconComponent } from './help-icon.component';
import { HelpPopoverComponent } from './help-popover.component';

@NgModule({
  declarations: [
    HelpIconComponent,
    HelpPopoverComponent
  ],
  imports: [CommonModule,
    IonicModule
  ],
  exports: [
    HelpIconComponent
  ]
})
export class HelpIconModule { }
